module.exports = __webpack_public_path__ + "img/healthcare-email-management.1ac30dfd.webp";